import { ArrowDown } from '@phosphor-icons/react';
import { cn } from '@/lib/utils';

interface ChatNewMessagesPillProps {
  /** Take the reader to the live edge. */
  onClick: () => void;
  className?: string;
}

/**
 * The "there is more below" affordance (ORA-599).
 *
 * The thread never moves a reader who has scrolled up to re-read something,
 * which used to mean an answer could finish entirely off screen with nothing
 * to say so. This is that signal: it floats over the bottom of the thread,
 * and tapping it returns them to the live edge.
 *
 * Presentational on purpose — the thread owns when it is on screen.
 */
const ChatNewMessagesPill = ({
  onClick,
  className,
}: ChatNewMessagesPillProps) => (
  <div
    className={cn(
      'chat-motion pointer-events-none absolute inset-x-0 bottom-3 z-20 flex justify-center px-3',
      className
    )}
  >
    <button
      type="button"
      onClick={onClick}
      aria-label="Scroll to latest messages"
      title="Scroll to latest messages"
      className="animate-chat-pop-in pointer-events-auto inline-flex size-11 cursor-pointer items-center justify-center rounded-full border border-border-subtle bg-surface-raised/95 text-fg-primary shadow-low backdrop-blur transition-colors outline-none hover:bg-surface-muted focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 dark:shadow-none"
    >
      <ArrowDown size={16} weight="bold" aria-hidden="true" />
    </button>
  </div>
);

export default ChatNewMessagesPill;
